import { render } from "./summaryTabOrderClient.vue?vue&type=template&id=f778144e&ts=true"
import script from "./summaryTabOrderClient.vue?vue&type=script&lang=ts"
export * from "./summaryTabOrderClient.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__